<template>
  <div id="input_business">
    <ul>
      <li>
        <span>
          <label class="list_key">{{label.businessName}}</label>
          <label class="important">必須</label>
        </span>
        <input type="text" class="list_box" v-model="form.businessName" maxlength="32"  placeholder="施主名(物件名)・会社名など"/>
        <div v-if="errors.businessName" class="error_text">{{errors.businessName}}</div>
      </li>
      <li>
        <span>
          <label class="list_key">{{label.building}}</label>
        </span>
        <input type="text" class="list_box" v-model="form.building" maxlength="32"  placeholder="建物名"/>
      </li>
      <li>
        <span>
          <label class="list_key">
              <label>{{label.postcd}}</label>
          </label>
          <label class="small_p">（半角数値、ハイフン不要）</label>
          <label class="important">必須</label>
        </span>
        <input type="text" disabled="disabled" class="list_box" v-model="form.postcd" @keypress="validateNumber" @input="form.postcd=inputRestNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="0001111"/>
        <div v-if="errors.postcd" class="error_text">{{errors.postcd}}</div>
      </li>
      <li>
        <span>
          <label>{{label.address}}</label>
          <label class="important">必須</label>
        </span>
        <span class="list_box">
          <input type="text" disabled="disabled" v-model="form.state" placeholder="都道府県">
          <input type="text" disabled="disabled" v-model="form.city" placeholder="市区町村">
        </span>
        <div v-if="errors.state" class="error_text">{{errors.state}}</div>
      </li>
      <li>
        <span>
          <label class="list_key">{{label.street}}</label>
          <label class="important">必須</label>
        </span>
        <input type="text" class="list_box" v-model="form.street" placeholder="町名" maxlength="32">
        <div v-if="errors.street" class="error_text">{{errors.street}}</div>
      </li>
      <li>
        <span>
          <label class="list_key">{{label.userName}}</label>
          <label class="important">必須</label>
        </span>
        <span class="list_box">
          <input type="text" v-model="form.userLastName" maxlength="32" placeholder="家具"/>
          <input type="text" v-model="form.userFirstName" maxlength="32" placeholder="太郎"/>
        </span>
        <div v-if="errors.userName" class="error_text">{{errors.userName}}</div>
      </li>
      <li>
        <span>
          <label class="list_key">{{label.userNameKana}}</label>
          <label class="important">必須</label>
        </span>
        <span class="list_box">
          <input type="text" v-model="form.userLastNameKana" maxlength="32" placeholder="カグ"/>
          <input type="text" v-model="form.userFirstNameKana" maxlength="32" placeholder="タロウ"/>
        </span>
        <div v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</div>
      </li>
      <li>
        <span>
          <label class="list_key">{{label.tel}}</label>
          <label class="small_p">（半角数値、ハイフン不要）</label>
          <label class="important">必須</label>
        </span>
        <input type="text" class="list_box" v-model="form.tel" @keypress="validateNumber" @input="form.tel=inputRestNumber($event)" oninput="if(value.length>16)value=value.slice(0,16)" placeholder="0123456789"/>
        <div v-if="errors.tel" class="error_text">{{errors.tel}}</div>
      </li>
    </ul>
    <!-- ローディングモーダル -->
    <!-- <dd-loading-modal ref="loadingModalRef" /> -->
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'
// import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'OrderInput',
  components: {
    // 'dd-loading-modal': LoadingModal
  },
  props: {
    label: Object,
    form: Object
  },
  data () {
    return {
      errors: {}
    }
  },
  methods: {
    confirm: function () {
      // 入力エラーのクリア
      // this.$refs.loadingModalRef.showModal(true)
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return false
      }
      return true
      // this.$refs.loadingModalRef.showModal(false)
    },
    validateRequire: function () {
      // 必須チェック
      if (!this.form.postcd) this.errors['postcd'] = this.label.postcd + 'は必須項目です。'
      if (!this.form.state || !this.form.city) this.errors['state'] = this.label.state + 'は必須項目です。'
      if (!this.form.street) this.errors['street'] = this.label.street + 'は必須項目です。'
      if (!this.form.tel) this.errors['tel'] = this.label.tel + 'は必須項目です。'
      if (!this.form.businessName) this.errors['businessName'] = this.label.businessName + 'は必須項目です。'
      if (!this.form.userLastName || !this.form.userFirstName) this.errors['userName'] = this.label.userName + 'は必須項目です。'
      if (!this.form.userLastNameKana || !this.form.userFirstNameKana) this.errors['userNameKana'] = this.label.userNameKana + 'は必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isPostCd(this.form.postcd)) this.errors['postcd'] = this.label.postcd + 'は半角数値で入力してください。'
      if (!Check.isTel(this.form.tel)) this.errors['tel'] = this.label.tel + 'は半角数値で入力してください。'
      if (!Check.isKana(this.form.userLastNameKana) || !Check.isKana(this.form.userFirstNameKana)) this.errors['userNameKana'] = this.label.userNameKana + 'はカタカナで入力してください。'
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    }
  },
  computed: {
    isConfirm: function () {
      if (this.form.postcd && this.form.state && this.form.city && this.form.street) {
        return true
      }
      return false
    }
  },
  watch: {
  },
  mounted () {
  },
  created () {
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/order/BusinessInput.vue